import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingSpinner from '../LoadingSpinner';

/**
 * RestrictedFromSalesRoute Component
 * 
 * A route wrapper that blocks sales role from accessing certain routes.
 * Allows user, admin, and super_admin roles.
 * If the user is not authenticated, they are redirected to the login page.
 * If the user is authenticated but has sales role, they are redirected to bank parsing.
 * Shows a loading spinner while checking authentication status.
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render if user has access
 * @returns {JSX.Element} The protected content, a redirect to login, or a redirect to bank parsing
 */
const RestrictedFromSalesRoute = ({ children }) => {
  const { user, isAuthenticated, loading } = useAuth();

  // Show loading spinner while checking authentication
  if (loading) {
    return <LoadingSpinner />;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // Block sales role - redirect them to their home (bank parsing)
  if (user?.role === 'sales') {
    return <Navigate to="/bank-parsing/analyze" />;
  }

  // Render children if authenticated and user is not sales
  return children;
};

export default RestrictedFromSalesRoute;

